import type { State } from 'types';
import type { ContentCardCreatorProfile } from 'components/cards/content-card/types';
import type { InstagramPostsReporting } from 'modules/reporting/types';

type MapByInfluencerId = {
  [x: number]: ContentCardCreatorProfile
};

export const mapInfluencersById = (
  {
    reportingV2
  }: State
): MapByInfluencerId => {
  const influencersMapById = {};
  reportingV2.summary?.influencerProfiles?.forEach(profile => {
    influencersMapById[profile.id] = profile;
  });

  return influencersMapById;
};

export const mapTikTokInfluencersById = (
  {
    tiktokReporting
  }: State
): MapByInfluencerId => {
  const influencersMapById = {};
  tiktokReporting.data?.influencerProfiles?.forEach(profile => {
    influencersMapById[profile.id] = profile;
  });

  return influencersMapById;
};

export const mapInstagramInfluencersById = (instagramPostsReporting: InstagramPostsReporting): MapByInfluencerId => {
  const influencersMapById = {};
  instagramPostsReporting?.influencerProfiles?.forEach(profile => {
    if (profile?.id) {
      influencersMapById[profile.id] = profile;
    }
  });

  return influencersMapById;
};
